import createPersistedState from 'use-persisted-state';

export const useTestModeState = (initialState?: boolean) =>
  createPersistedState<boolean>('m-test-mode')(Boolean(initialState));
